import { useEffect, useState } from 'react';
import {
  timestamp,
  useDateUpdate
  //  usePageViews
} from 'src/utils/helper';
import styled from 'styled-components';
// import { FaRegCalendarAlt, FaRegEye } from 'react-icons/fa';
import _ from 'lodash';
import { useCountviews } from 'src/utils/countview';
import { sendDataLayerGlobal } from 'src/utils/datalayer/send-datalayer';

const CardHighlight = ({ data, showTime = true, external = false, excerpt = 2, showCountview = true, eventDataLayer }) => {
  if (_.isEmpty(data)) return null;
  const [countView, setCountView] = useState(data.pageviews || 0);
  useEffect(
    () =>
      (async () => {
        try {
          const _pageviews = await useCountviews(data);
          setCountView(_pageviews);
        } catch (err) {
          console.error(`${timestamp()} ==========> CARD_H ERROR :`, err.message);
        }
      })(),
    []
  );
  const badge = data?.subCategory?.th ? data?.subCategory?.th : data?.section?.th;

  const dateUpdate = useDateUpdate(data?.published_at);

  return (
    <>
      <CardWrapper className='card-h'>
        <a
          href={data?.link}
          tabIndex='-1'
          title={data?.title}
          target={external ? '_blank' : '_self'}
          rel={external ? 'noopener noreferrer nofollow' : ''}
          //! DATALAYER
          onClick={() => sendDataLayerGlobal({ ...eventDataLayer })}
        >
          <div className='content-detail d-flex-only d-lg-block'>
            <div className='sub-text-hlghlight'>
              <p>{badge}</p>
            </div>
            <h2 className={`text-excerpt-${excerpt} m-0`}>{data?.title}</h2>
            <div className='meta'>
              <div className='post-date-light'>
                <ul>
                  <li className='date'>
                    {/* <FaRegCalendarAlt /> */}
                    <span>{dateUpdate}</span>
                  </li>
                  {/* {showCountview && (countView > 0 || data.pageviews > 0) && (
                    <li className='pageview'>
                      <FaRegEye /> {usePageViews(countView) || usePageViews(data?.pageviews)}
                    </li>
                  )} */}
                </ul>
              </div>
            </div>
          </div>
        </a>
      </CardWrapper>
    </>
  );
};

const CardWrapper = styled.div`
  cursor: pointer;
  &:hover {
    &.card-h {
      h2 {
        color: var(--primary-color);
        text-decoration: underline;
        text-decoration-color: #fff;
      }
    }
    .sub-text-hlghlight {
      p {
        color: var(--primary-color) !important;
      }
    }
    .post-date-light {
      p,
      svg,
      span,
      li {
        color: var(--primary-color) !important;
      }
    }
  }
  &.card-h {
    margin-top: 1rem;
    margin-left: auto;

    .content-detail {
      h2 {
        font-size: 18px;
        font-weight: 400;
      }
    }

    .sub-text-hlghlight {
      text-transform: uppercase;
      color: #fff;
      width: fit-content;
      p {
        font-weight: 600;
        font-size: 14px;
      }
    }

    h2 {
      transition: 0.5s ease-out;
      color: #fff;
      font-size: 16px;
      line-height: 1.75;
      padding: 8px 8px 0 0;
      font-weight: 500;
    }
    .d-flex-only {
      @media (max-width: 1024px) and (min-width: 768px) {
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
      }
    }
    .post-date-light {
      padding: 0 10px 5px 0;
      ul {
        display: flex;
        justify-content: space-between;
        list-style-type: none;
        padding-left: 0;
        margin-top: 0;
        li {
          &.date {
            margin-right: 10px;
          }
          svg {
            margin-right: 5px;
            margin-bottom: 2px;
          }
          svg,
          span {
            vertical-align: middle;
            font-size: 12px;
            font-weight: 300;
            color: #fff;
          }
          @media (max-width: 768px) {
            svg,
            span {
              font-size: 11px;
            }
          }
        }
        .pageview {
          font-size: 12px;
          font-weight: 300;
          color: #fff;
          margin-top: 5px;

          svg {
            margin-bottom: 3px;
          }
        }
      }
    }
  }
`;

export default CardHighlight;
